module.exports = __webpack_public_path__ + "img/Logo-Smalll.1259f7c9.png";